import React from 'react';
import * as PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';
import ScheduleIcon from '@material-ui/icons/Schedule';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

// 'sent' (and receiver-synced inbound mail) is the normal case and gets no
// icon at all - only the exceptional states are worth calling out here.
const EmailStatusIndicator = ({ status, failedReason, fontSize, outbound }) => {
    if (status === 'pending') {
        return (
            <Tooltip title="Wird gesendet …">
                <ScheduleIcon fontSize={fontSize} color="disabled" />
            </Tooltip>
        );
    }

    if (status === 'failed') {
        return (
            <Tooltip
                title={
                    failedReason
                        ? `Versand fehlgeschlagen: ${failedReason}`
                        : 'Versand fehlgeschlagen'
                }
            >
                <ErrorOutlineIcon fontSize={fontSize} color="error" />
            </Tooltip>
        );
    }

    // received mail has nothing to confirm, only outbound mail can be unconfirmed
    if (status === 'unknown' && outbound) {
        return (
            <Tooltip title="Der Versand dieser E-Mail kann nicht offiziell bestätigt werden.">
                <InfoOutlinedIcon fontSize={fontSize} color="disabled" />
            </Tooltip>
        );
    }

    return null;
};

EmailStatusIndicator.propTypes = {
    status: PropTypes.oneOf(['pending', 'sent', 'failed', 'unknown']),
    failedReason: PropTypes.string,
    fontSize: PropTypes.oneOf(['inherit', 'default', 'small', 'large']),
    outbound: PropTypes.bool,
};

EmailStatusIndicator.defaultProps = {
    status: null,
    failedReason: null,
    fontSize: 'small',
    outbound: false,
};

export default EmailStatusIndicator;
